<template>
	<div class="game-screen">
		<div class="game-stage">
			<Board
				:isReviewing="isReviewing"
				:fillTiles="fillTiles"
				:stage="stage"
				:catComponentType="componentTypes.cat"
			/>
			<CycleSummary v-if="isReviewing" />
			<Interface
				:foodbagComopnent="componentTypes.foodBag"
				:timebarComopnent="componentTypes.timebar"
				ref="interface"
				:name="stage.name"
				:scale="stage.cat_scale"
				:speed="stage.speed_multiplier"
			/>
		</div>
	</div>
</template>

<script>
import Board from '@/components/board/Board';
import Interface from '@/components/board/Interface';
import CycleSummary from '@/components/board/CycleSummary';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	name: 'GameStage',
	components: {
		Board,
		Interface,
		CycleSummary,
	},
	props: {
		fillTiles: { default: true },
		stage: { default: null },
		componentTypes: {
			default() {
				return {
					cat: "Cat",
					foodBag: 'FoodBag',
					timebar: 'TimeBar',
				};
			},
		},
	},
	provide() {
		return {
			offset: {
				offset: this.stage.offset_cat_positions,
				offset_amount: this.stage.offset_amount,
				flip: this.stage.flip_cats,
			},
			catComponentType: this.componentTypes.cat,
		};
	},
	computed: {
		...mapState({
			activeCycle: state => state.cycle.active,
			tileCount: state => state.board.tiles.length,
			gameOver: state => state.gameOver,
			isReviewing: state => state.cycle.reviewing,
			tutorialComplete: state => state.tutorial.complete,
			tutorialActive: state => state.tutorial.active,
			remainingSpawns: state => state.spawner.remainingSpawns,
		}),
		...mapGetters([
			"vacantTiles",
			"occupiedTiles",
			"blockedTiles",
			"activeCatCount",
			"cycleExists",
		]),
		allCatsCleared() {
			return this.occupiedTiles.length === 0;
		},
		allCatsSpawned() {
			return this.occupiedTiles.length === this.activeCatCount;
		},
		stageComplete() {
			return !this.activeCycle && (this.vacantTiles.length <= this.activeCatCount);
		},
	},
	watch: {
		isReviewing(isReviewing, wasReviewing) {
			if (!isReviewing && wasReviewing && this.stageComplete && !this.stage.final_stage) {
				this.logStageCompleteEvent();
				this.$store.dispatch("loadNextStage");
			}

			if (!isReviewing && wasReviewing && this.tutorialComplete && this.tutorialActive) {
				this.$store.dispatch("loadStage");
			}
		},
		remainingSpawns(remainingSpawns, previousSpawns) {
			if (remainingSpawns === 0 && previousSpawns >= 1 && this.gameOver) {
				this.logStageCompleteEvent();
				this.$store.dispatch("loadGameOver");
			}
		},
	},
	methods: {
		...mapActions([
			"startClock",
			"stopClock",
			"endCycle",
			"sendEvent",
		]),
		logStageCompleteEvent() {
			this.sendEvent({
				ec: "Game",
				ea:	`${this.stage.name} Complete`,
				el: `Day ${this.$store.state.cycle.completedGameCycles}`,
			});
		},
		watchTiles() {
			this.$watch('allCatsCleared', (allEmpty) => {
				if (allEmpty && this.cycleExists) {
					this.endCycle();
				}
			});
		},
	},
	mounted() {
		this.startClock();

		this.$nextTick(() => {
			this.watchTiles();
		});
	},
	beforeDestroy() {
		this.stopClock();
	},
};
</script>

<style lang="scss" scoped>
	.game-stage {
		display: flex;
		width: 100%;
		height: 100%;
		flex-direction: column;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/GameStage.vue